module.exports = __webpack_public_path__ + "img/purchase_complete.522a817b.svg";